var map = {
	"./cast.JPG": 75486,
	"./contact.JPG": 68267,
	"./doorgespeeld.JPG": 88556,
	"./galerij.JPG": 34999,
	"./lang_en_gelukkig.JPG": 99237,
	"./spelling_bee.JPG": 6548
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53443;